export default __webpack_public_path__ + "static/media/Bandeau 24 HD.8b414102.jpg";